import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import MonotypeLogo from "../../assets/svg-icons/brandLogo";
import gsap from "gsap";
import ExploreButton from "../../assets/svg-icons/exploreButton";
import { useFonts } from "../../hooks/useFonts";
import { isMobile } from "react-device-detect";

const Home = () => {
  useFonts()
  const navigate = useNavigate();
  const handleNavigate = () => navigate('/playground');

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      navigate('/playground');
    }, 3000);

    return () => clearTimeout(redirectTimeout);
  }, [navigate]);

  useEffect(() => {
    gsap.context(() => {
      const cursorEye = document.querySelector(".cursor-eye");
      const target = cursorEye.querySelector('.text');

      function animateText() {
        const loopAnim = gsap.to(target, {
          rotation: "+=360",
          transformOrigin: "center",
          ease: "none",
          duration: 15,
          onComplete: () => {
            loopAnim.play(0);
          },
          paused: false
        });
      }

      function mousemoveHandler(e) {

        const tl = gsap.timeline({
          defaults: {
            x: e.clientX - 100,
            y: e.clientY - 100,
            ease: "power2.out"
          }
        });
        tl.to(cursorEye, {
          opacity: 1
        });
        animateText();
      };
      document.addEventListener("mousemove", mousemoveHandler);

      if(isMobile) {
        animateText();
      }
  }
  );
    
    
});


return (
  <div className="page-wrapper splash-screen">
    {/* <Header showBurgerMenu="showBurgerMenu" hideActionBar="hideActionBar" setShowSidebar={setShowSidebar} showSidebar={showSidebar} /> */}
    {/* <div className="page-header">
      <div className="header-left">
        <div className="brand-logo">
          <Link to="/"><MonotypeLogo /></Link>
        </div>
      </div>
    </div> */}
    <div onClick={handleNavigate} className="landingPage-content">
      <main className="main-content custom-cursor align-items-start">
        <div className="landing-font-content">
          <div className="row">
            <div className="col-md-12 col-12 text-center">
              <h2 fetch-priority="high">EXPLORE</h2>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6 col-12 text-left heading2">
              <h2 fetch-priority="high">FONT</h2>
            </div>
            <div className="col-md-6 col-12 d-md-block d-none">
              <h1 fetch-priority="high" className="landing-small">
              Find the perfect font pairing powered by the Monotype AI pairing engine.
              </h1>
            </div>
          </div>
          <div className="row circularBox">
            <div className="col-md-10 col-12 offset-md-2 text-md-start text-center">
              <h2 fetch-priority="high">PAIRS</h2>
              {/* <div className="inner-animator-landing">
                  <Link to={ROUTES.PLAYGROUND}>
                    <img
                      src={CircularText}
                      alt="circle"
                      className="sc-dFdIVH eUKLbf"
                    />
                  </Link>
                  <div className="middle-arrow">
                    <img
                      src={RightArrow}
                      alt="Arrow"
                      className="sc-brCFrO dFiDPF"
                    />
                  </div>
                </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-12 d-md-none d-block">
              <p className="landing-small text-left m-auto mt-4">
              Find the perfect font pairing powered by the Monotype AI pairing engine.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div className="cursor cursor-eye" >
    <ExploreButton />
    </div>

    {/* <SmoothLoader /> */}
  </div>
);
};

export default Home;
